import React from 'react';
import { APIs } from '../modules/apiClient';
import http from '../modules/api';
import SelectBoxV2, {getSelectBoxSelectIdx} from '../modules/common/SelectBoxV2';
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import Button from '../modules/common/Button';
import CheckBox from '../modules/common/CheckBox';

export default class RpSelectCategory extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            iframePageId: props.iframePageId || "",
            cafe24CategoryList: props.cafe24CategoryList || [],

            is_check_same_category: props.is_check_same_category || false,

            category_no_1: props.category_no_1 || "",
            category_no_2: props.category_no_2 || "",
            category_no_3: props.category_no_3 || "",
            category_no_4: props.category_no_4 || "",
            
            category_list_1: props.category_list_1 || [],
            category_list_2: props.category_list_2 || [],
            category_list_3: props.category_list_3 || [],
            category_list_4: props.category_list_4 || [],
        }
    }

    componentWillMount() {
	
    }

	componentDidMount() {
        if (!this.props.category_list_1 || this.props.category_list_1.length === 0) {
            this.loadProductCategory(1, 1);
        } else {
            this.setState({
                category_list_1: this.props.category_list_1,
                category_list_2: this.props.category_list_2,
                category_list_3: this.props.category_list_3,
                category_list_4: this.props.category_list_4,
            });
        }
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    onChangeRpCategory = (text, value, id) => {
        const current_category = id;
        const depth = Number(current_category.split('_')[4])+1;
        var category_name = "category_no_"+(Number(depth)-1);
        var event_category_list;
            
        // 전체상품을 선택한 경우, 대카테고리가 아니면 상위 카테고리 번호를 대표 카테고리 번호로 설정
        if((value=="전체상품" || value == "")){
            if(Number(depth)>2){
                const parent_category_no = this.state["category_no_"+(Number(depth)-2)];
                event_category_list = parent_category_no;
            } else{ // 대카테고리인 경우 ""로 변경
                event_category_list = "";
            }
        }else{
            event_category_list = value;
        }
        this.setState({
            [category_name] : value,
        }, () => {
            if (typeof this.props.onCategoryChange === 'function') {
                console.log("빈문자 여부:", (this.state.category_no_1 == ""));
                this.props.onCategoryChange(
                    this.state.category_no_1,
                    this.state.category_no_2,
                    this.state.category_no_3,
                    this.state.category_no_4,
                    this.state.category_list_1,
                    this.state.category_list_2,
                    this.state.category_list_3,
                    this.state.category_list_4,
                );
            }
        })

        // 세분류가 아니라면 하위카테고리 관련 작업을 진행
        if (depth < 5) {
            const nextListName = "category_list_" + depth;
            const newState = {};
        
            if (value !== "전체상품" && value !== "") {
                this.loadProductCategory(value, depth); // 비동기 별도 처리
            } else {
                newState[nextListName] = [];
            }
        
            // 이후 단계 초기화
            for (let idx = depth + 1; idx <= 4; idx++) {
                newState["category_list_" + idx] = [];
                newState["category_no_" + idx] = "";
            }
        
            // 현재 depth의 선택된 값 저장
            newState["category_no_" + (depth - 1)] = value;

            this.setState(newState, () => {
                if (typeof this.props.onCategoryChange === "function") {
                    this.props.onCategoryChange(
                        this.state.category_no_1,
                        this.state.category_no_2,
                        this.state.category_no_3,
                        this.state.category_no_4,
                        this.state.category_list_1,
                        this.state.category_list_2,
                        this.state.category_list_3,
                        this.state.category_list_4,
                    );
                }
            });
        }
    }

    setStateAsync = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, resolve);
        });
    }

    notifyCategoryChange = () => {
        if (typeof this.props.onCategoryChange === "function") {
            this.props.onCategoryChange(
                this.state.category_no_1,
                this.state.category_no_2,
                this.state.category_no_3,
                this.state.category_no_4,
                this.state.category_list_1,
                this.state.category_list_2,
                this.state.category_list_3,
                this.state.category_list_4,
            );
        }
    }

    async loadProductCategory(parentCategory, depth) {
        try {
            const res = await APIs.rp.getRoboMDCategory(
                this.props.user_seq,
                this.props.shop_no,
                parentCategory
            );

            const name = "category_list_" + depth;
            const name2 = "category_no_" + depth;
            const list = res.data.list || [];

            if (list.length > 0) {
                if (this.props.is_exclude) {
                    if (depth == 1) {
                        list.splice(0, 0, {
                            category_name: "사용안함",
                            category_name_no_format: "사용안함",
                            category_no: ""
                        });
                    } else {
                        list.splice(0, 0, {
                            category_name: "전체상품",
                            category_name_no_format: "전체상품",
                            category_no: "전체상품"
                        });
                    }
                } else {
                    list.splice(0, 0, {
                        category_name: "전체상품",
                        category_name_no_format: "전체상품",
                        category_no: "전체상품"
                    });
                }
            }

            await this.setStateAsync({
                [name]: list,
                [name2]: ""
            });

            this.notifyCategoryChange();

            return list;
        } catch (error) {
            return [];
        }
    }

    applyCafe24CategoryPath = async () => {
        const cafe24CategoryList = this.state.cafe24CategoryList || [];

        if (!cafe24CategoryList.length) {
            return;
        }

        await this.setStateAsync({
            category_no_1: "",
            category_no_2: "",
            category_no_3: "",
            category_no_4: "",
            category_list_2: [],
            category_list_3: [],
            category_list_4: [],
        });

        this.notifyCategoryChange();

        let appliedDepth = 0;

        for (let i = 0; i < cafe24CategoryList.length && i < 4; i++) {
            const depth = i + 1;
            const categoryNo = cafe24CategoryList[i];

            if (!categoryNo) {
                break;
            }

            const resetState = {};
            for (let j = depth + 1; j <= 4; j++) {
                resetState["category_no_" + j] = "";
                resetState["category_list_" + j] = [];
            }

            await this.setStateAsync({
                ["category_no_" + depth]: categoryNo,
                ...resetState
            });

            this.notifyCategoryChange();

            appliedDepth = depth;

            if (depth < 4) {
                await this.loadProductCategory(categoryNo, depth + 1);
            }
        }

        // 마지막 적용 depth 이후 하위 카테고리 강제 초기화
        const finalResetState = {};
        for (let j = appliedDepth + 1; j <= 4; j++) {
            finalResetState["category_no_" + j] = "";
            finalResetState["category_list_" + j] = [];
        }

        if (Object.keys(finalResetState).length > 0) {
            await this.setStateAsync(finalResetState);
            this.notifyCategoryChange();
        }
    }

    onClickApplySameCategory = async () => {
        if (typeof this.props.onClickApplySameCategory === "function") {
            this.props.onClickApplySameCategory();
        }

        await this.applyCafe24CategoryPath();
    }

    render() {
        return (
            <div>
                <div class="list_select_margin" style={{width:"350px"}}>
                    <div class="list_category_select_box">
                        <SelectBoxV2
                            id={"product_rp_category_no_1"+(this.props.id? "_"+this.props.id:"")}
                            // tabIndex={obj.self_select_area_checked ? 0 : ""}
                            width="100%"
                            height="36px"
                            padding="14px 36px 14px 16px"
                            list= {this.state.category_list_1}
                            optionTexttName = "category_name_no_format"
                            optionValuetName = "category_no"
                            selectedValue = {this.props.is_exclude? this.state.category_no_1 : (this.state.category_no_1 == "" ? "전체상품" : this.state.category_no_1)}
                            onClickOption={this.onChangeRpCategory.bind(this)}
                            selectAreaMaxHeight = "456px"
                            boundingSelector = {this.props.boundingSelector ? this.props.boundingSelector : ""}
                        />
                    </div>
                    {
                        this.state.category_list_2 != null && this.state.category_list_2.length > 0
                        ?<div class="list_category_select_box list_category_select_box_1">
                            <SelectBoxV2
                                id={"product_rp_category_no_2"+(this.props.id? "_"+this.props.id:"")}
                                // tabIndex={obj.self_select_area_checked ? 0 : ""}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.category_list_2}
                                optionTexttName = "category_name_no_format"
                                optionValuetName = "category_no"
                                selectedValue = {this.props.is_exclude? (!this.state.category_no_2 ? "전체상품" : this.state.category_no_2) : (this.state.category_no_2 == "" ? "전체상품" : this.state.category_no_2)}
                                onClickOption={this.onChangeRpCategory.bind(this)}
                                selectAreaMaxHeight = "456px"
                                boundingSelector = {this.props.boundingSelector ? this.props.boundingSelector : ""}
                            />
                        </div>
                        :   ""
                    }
                    {
                        this.state.category_list_3 != null && this.state.category_list_3.length > 0
                        ?<div class="list_category_select_box list_category_select_box_1">
                            <SelectBoxV2
                                id={"product_rp_category_no_3"+(this.props.id? "_"+this.props.id:"")}
                                // tabIndex={obj.self_select_area_checked ? 0 : ""}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.category_list_3}
                                optionTexttName = "category_name_no_format"
                                optionValuetName = "category_no"
                                selectedValue = {this.props.is_exclude? (!this.state.category_no_3 ? "전체상품" : this.state.category_no_3) : (this.state.category_no_3 == "" ? "전체상품" : this.state.category_no_3)}
                                onClickOption={this.onChangeRpCategory.bind(this)}
                                selectAreaMaxHeight = "456px"
                                boundingSelector = {this.props.boundingSelector ? this.props.boundingSelector : ""}
                            />
                        </div>
                        :   ""
                    }
                    {
                        this.state.category_list_4 != null && this.state.category_list_4.length > 0
                        ?<div class="list_category_select_box list_category_select_box_1">
                            <SelectBoxV2
                                id={"product_rp_category_no_4"+(this.props.id? "_"+this.props.id:"")}
                                // tabIndex={obj.self_select_area_checked ? 0 : ""}
                                width="100%"
                                height="36px"
                                padding="14px 36px 14px 16px"
                                list= {this.state.category_list_4}
                                optionTexttName = "category_name_no_format"
                                optionValuetName = "category_no"
                                selectedValue = {this.props.is_exclude? (!this.state.category_no_4 ? "전체상품" : this.state.category_no_4) : (this.state.category_no_4 == "" ? "전체상품" : this.state.category_no_4)}
                                onClickOption={this.onChangeRpCategory.bind(this)}
                                selectAreaMaxHeight = "456px"
                                boundingSelector = {this.props.boundingSelector ? this.props.boundingSelector : ""}
                            />
                        </div>
                        :   ""
                    }
                </div>
                {
                    this.state.iframePageId == "robomd_cafe24_category_page"
                    ?   <div style={{margin:"15px 0px 0px 0px"}}>
                             <button
                                className="common_button hover_white" 
                                style={{width:"250px", height:"36px", fontSize:"14px"}}
                                onClick={this.onClickApplySameCategory}
                            >카테고리를 진열 위치와 동일하게 적용</button>
                        </div>
                    : ""
                }
            </div>
        )
    };
}